import React from 'react'

interface StampSheetArrowProps {
  onClick: () => void
  position: 'left' | 'right'
  hide: boolean
}

export const StampSheetArrow = ({ onClick, position, hide }: StampSheetArrowProps) => {
  return (
    <button
      type="button"
      className={`absolute top-[68px] z-10 ${position === 'left' ? 'left-[13px]' : 'right-[13px]'}`}
      onClick={onClick}
      style={{
        opacity: hide ? '0' : '1',
        pointerEvents: hide ? 'none' : 'auto',
      }}
    >
      <img src={`${process.env.NEXT_PUBLIC_SITEURL}/images/common/icon/icon_arrow_${position}.svg`} alt="" />
    </button>
  )
}
